import React from "react";

// Compact, very transparent glass card so the background artwork stays visible.
export const GLASS = "rounded-3xl border border-gold/35 bg-[#031C15]/25 backdrop-blur-md p-5 sm:p-6 shadow-[0_20px_60px_rgba(0,0,0,0.45),0_0_30px_rgba(212,175,55,0.12)]";

// Outer layout: card sits bottom-right on desktop and at the bottom on phones, leaving the artwork in view.
export const SHELL = "relative min-h-screen flex items-end justify-center lg:justify-end p-4 pt-60 sm:pt-56 lg:p-10 lg:pt-44 lg:pr-14";

const Hairline = () => (
  <div className="flex items-center justify-center gap-3 text-gold/80">
    <span className="h-px w-16 sm:w-32 bg-gradient-to-r from-transparent to-gold/80" />
    <span className="text-[10px] tracking-[0.5em]">✦ ✧ ✦</span>
    <span className="h-px w-16 sm:w-32 bg-gradient-to-l from-transparent to-gold/80" />
  </div>
);

// Celestial ribbon: the full Talbiyah floats over the sky at the top of the screen, no box behind it.
export const Talbiyah = () => (
  <div className="pointer-events-none absolute top-0 inset-x-0 z-20 px-4 pt-4 pb-10 text-center bg-gradient-to-b from-black/55 via-black/20 to-transparent" data-testid="login-dua">
    <Hairline />
    <p className="talbiyah-shimmer mx-auto max-w-5xl text-[1.35rem] sm:text-3xl lg:text-[2.2rem] leading-[1.75] mt-1" style={{ fontFamily: "'Amiri', serif", letterSpacing: 0 }} dir="rtl" lang="ar">
      لَبَّيْكَ اللَّهُمَّ لَبَّيْكَ، لَبَّيْكَ لَا شَرِيكَ لَكَ لَبَّيْكَ، إِنَّ الْحَمْدَ وَالنِّعْمَةَ لَكَ وَالْمُلْكَ، لَا شَرِيكَ لَكَ
    </p>
    <p className="mx-auto max-w-4xl text-[11px] sm:text-sm text-white font-semibold tracking-wide drop-shadow-[0_2px_6px_rgba(0,0,0,0.9)]">
      Labbaik Allahumma Labbaik, Labbaik La Shareeka Laka Labbaik, Innal Hamda Wan-Ni'mata Laka Wal-Mulk, La Shareeka Lak
    </p>
    <p className="hidden sm:block mx-auto max-w-4xl text-xs text-white/80 italic mt-1 drop-shadow-[0_2px_6px_rgba(0,0,0,0.9)]">
      Here I am, O Allah, here I am. Here I am, You have no partner, here I am. Surely all praise, grace and sovereignty belong to You. You have no partner.
    </p>
    <div className="mt-2"><Hairline /></div>
  </div>
);
